import http from '../utils/fetch'
import * as Login from './login'
import { AnyCnameRecord } from 'dns'
import internal from 'stream'
export interface ContentParamsType {
	st_fileurl: string // 上传文件地址
	st_text_title: string // 内容标题
	st_skuid?: string // skuid
	st_type: number // 内容形式
	st_authorize_file1?: string // 授权文件地址1
	st_authorize_file2?: string // 授权文件地址2
	st_authorize_file3?: string // 授权文件地址3
	st_source: string // 来源
	st_bl: string // 业务线
	st_category: string // 场景分类
	st_tag: string // 内容标签
	st_authorize_date_s?: string // 有效开始时间
	st_authorize_date_e?: string // 有效结束时间
	id?: string // id
	[propName: string]: any
}
/**
 * 根据关键词和城市id查景区
 */
export function getSearchList(params: any) {
	return http.post(`etl/searchList`, {
		body: JSON.stringify(params),
	})
}
export function downloadTemplate() {
	return http.get(`infoManage/downloadTemplate`, {})
}
/**
 * 获取民宿城市列表
 */
export function getTcityHome(params: any) {
	return http.get(`etl/tcityHome`, {
		body: params,
	})
}
/**
 * 获取景区城市列表
 */
export function getAllCity(params: any) {
	return http.get(`etl/tcityAll`, {
		body: params,
	})
}
/**
 * 上传网络链接
 */
export function addFileForUrl(params: { fileurl: string }) {
	return http.post(`infoManage/addFileForUrl`, {
		body: JSON.stringify(params),
	})
}
/**
 * 上传网络资源
 */
export function addFile(myform: any) {
	return http.post(`infoManage/addFile`, {
		formData: true,
		body: myform,
	})
}
/**
 * 添加内容
 */
// export function addContent(params: ContentParamsType) {
export function addContent(params: any) {
	return http.post(`infoManage/add`, {
		body: JSON.stringify({
			st_is_works: '0',
			...params,
			is_del: '0',
		}),
	})
}

/**
 * 添加内容(新)
 */
// export function addContent(params: ContentParamsType) {
export function addContentNew(params: any) {
	return http.post(`hotelapprovalform/startHotelApprove`, {
		body: JSON.stringify({
			st_is_works: '0',
			...params,
			is_del: '0',
		}),
	})
}

/**
 * 修改内容
 */
// export function updateContent(params: ContentParamsType) {
export function updateContent(params: any) {
	return http.post(`infoManage/update`, {
		body: JSON.stringify(params),
	})
}

/**
 * 删除内容
 */
export function deleteContent(params: { ids: string[], reviewType?: string }) {
	return http.post(`infoManage/delete`, {
		body: JSON.stringify(params),
	})
}

/**
 * 删除内容(新)
 */
export function deleteContentNew(params: any) {
	return http.post(`hotelapprovalform/deleteApprove`, {
		body: JSON.stringify(params),
	})
}

// /**
//  * 审核内容
//  */
// export function reviewContent(params: any) {
// 	return http.post(`infoManage/review`, {
// 		body: JSON.stringify(params)
// 	})
// }

/**
 * 获取内容列表
 */
export function getContentList(params: any) {
	return http.post(`infoManage/select`, {
		body: JSON.stringify(params),
	})
}

/**
 * 获取内容详情
 */
export function getContentInfo(params: { id: string; mcn: boolean, reviewType?: string }) {
	return http.post(`infoManage/selectOne`, {
		body: JSON.stringify(params),
	})
}

/**
 * 获取内容详情(新)
 */
export function getContentInfoNew(params: { id: string; mcn?: boolean; reviewType?: string }) {
	const newParams:any = {
		businessKey: params.id,
		mcn: params.mcn,
	}
	if(params.reviewType) {
		newParams.reviewType = params.reviewType
	}
	return http.post(`hotelapprovalform/selectApprove`, {
		body: JSON.stringify(newParams),
	})
}

/**
 * 获取作品列表
 */
export function getWorkList(params: any) {
	const { workContentList } = params // TODO 作品素材列表
	const shouldQuery = workContentList.map((content: string) => {
		// 或 查询条件
		return { bool: { filter: { term: { st_works_info: content } } } }
	})
	return http.post(`infoManage/select`, {
		body: JSON.stringify({
			sort: [
				// 排序
				{ st_update_time: { order: 'DESC' } },
				{ st_create_time: { order: 'DESC' } },
			],
			query: {
				// 查询条件
				bool: {
					filter: [
						{ bool: { filter: { term: { is_del: '0' } } } },
						{ bool: { filter: { term: { st_is_works: '1' } } } },
						{ bool: { should: shouldQuery } },
					],
				},
			},
			...params,
		}),
	})
}

/**
 * 获取作品列表
 */
export function getDraftList(params: any, useId: any) {
	return http.post(`infoManage/select`, {
		body: JSON.stringify({
			sort: [
				// 排序
				{ st_update_time: { order: 'DESC' } },
				{ st_create_time: { order: 'DESC' } },
			],
			query: {
				// 查询条件
				bool: {
					filter: [
						{ bool: { filter: { term: { is_del: '0' } } } },
						{ bool: { filter: { term: { st_is_works: '1' } } } },
						{ bool: { filter: { term: { st_is_publish: '0' } } } },
						{ bool: { filter: { term: { st_create_work_id: useId } } } },
					],
				},
			},
			...params,
		}),
	})
}

/**
 * 保存至草稿箱
 */
export function addDraft(params: any) {
	return http.post(`infoManage/add`, {
		body: JSON.stringify({
			...params,
			is_del: '0',
			st_is_publish: 0, // 未发布
			st_is_works: '1',
		}),
	})
}

/**
 * 更新至草稿箱
 */
export function updateDraft(params: any) {
	return http.post(`infoManage/update`, {
		body: JSON.stringify({
			...params,
			is_del: '0',
			st_is_publish: 0, // 未发布
			st_is_works: '1',
		}),
	})
}

/**
 * 保存作品
 */
export function addWorks(params: any) {
	return http.post(`infoManage/add`, {
		body: JSON.stringify({
			...params,
			is_del: '0',
			st_is_works: '1',
			st_is_publish: '1',
		}),
	})
}

/**
 * 更新作品
 */
export function updateWorks(params: any) {
	return http.post(`infoManage/update`, {
		body: JSON.stringify({
			...params,
			is_del: '0',
			st_is_works: '1',
			st_is_publish: '1',
		}),
	})
}
/**
 * 获取分类（分页）
 */
export function getCategoriesByPage(params: any) {
	return http.post(`categorManage/select`, {
		body: JSON.stringify({
			isDel: 0,
			...params,
		}),
	})
}

/**
 * 获取分类（所有）
 */
export function getCategoriesAll(params?: any) {
	return http.post(`categorManage/selectAll`, {})
}

/**
 * 获取场景分类
 */
export function getCategories(params: {}) {
	return http.post(`categorManage/select`, {
		body: JSON.stringify(params),
	})
}

/**
 * 添加分类
 */
// export function addCategory(params: { name: string }) {
export function addCategory(params: any) {
	return http.post(`categorManage/add`, {
		body: JSON.stringify(params),
	})
}

/**
 * 修改分类
 */
// export function updateCategory(params: { name: string; id: number }) {
export function updateCategory(params: any) {
	return http.post(`categorManage/update`, {
		body: JSON.stringify(params),
	})
}

/**
 * 删除分类
 */
// export function deleteCategory(params: { id: number }) {
export function deleteCategory(params: any) {
	return http.post(`categorManage/delete`, {
		body: JSON.stringify(params),
	})
}

/**
 * 获取内容形式
 */
export function getContentType(params: {}) {
	return http.post(`typeManage/select`, {
		body: JSON.stringify(params),
	})
}

/**
 * 获取标签
 */
export function getAllTags() {
	return http.post(`tagManage/selectAll`, {})
}

/**
 * 获取标签（分页）
 */
export function getTags(params: any) {
	return http.post(`tagManage/select`, {
		body: JSON.stringify({
			isDel: 0,
			...params,
		}),
	})
}

/**
 * 新建标签
 */
export function addTag(params: any) {
	return http.post(`tagManage/add`, {
		body: JSON.stringify(params),
	})
}

/**
 * 修改标签
 */
export function updateTag(params: any) {
	return http.post(`tagManage/update`, {
		body: JSON.stringify(params),
	})
}

/**
 * 删除标签
 */
// export function deleteTag(params: { id: number }) {
export function deleteTag(params: any) {
	return http.post(`tagManage/delete`, {
		body: JSON.stringify(params),
	})
}

/**
 * 抓取配置 分页查询
 */
export function getReptile(params: any) {
	return http.post(`reptile/select`, {
		body: JSON.stringify(params),
	})
}

/**
 * 抓取配置 条件查询
 */
export function getReptileById(params: any) {
	return http.post(`reptile/query`, {
		body: JSON.stringify(params),
	})
}

/**
 * 抓取配置 添加
 */
export function addReptile(params: any) {
	return http.post(`reptile/add`, {
		body: JSON.stringify(params),
	})
}

/**
 * 抓取配置 修改
 */
export function updateReptile(params: any) {
	return http.post(`reptile/update`, {
		body: JSON.stringify(params),
	})
}

/**
 * 抓取配置 删除
 */
export function deleteReptile(params: { id: number }) {
	return http.post(`reptile/delete`, {
		body: JSON.stringify(params),
	})
}

/**
 * 实时爬取 网络链接
 */
export function grabFromWeb(params: { url: string }) {
	return http.get(`crawler/realTime`, {
		body: params,
	})
}

/**
 * 添加下发渠道（下发内容）
 */
export function addIssue(params: any) {
	return http.post(`issue/add`, {
		body: JSON.stringify(params),
	})
}

/**
 * 添加渠道
 */
export function addChannel(params: any) {
	return http.post(`channel/add`, {
		body: JSON.stringify(params),
	})
}

/**
 * 修改渠道
 */
export function updateChannel(params: any) {
	return http.post(`channel/update`, {
		body: JSON.stringify(params),
	})
}

/**
 * 删除渠道
 */
export function deleteChannel(params: { id: number }) {
	return http.post(`channel/delete`, {
		body: JSON.stringify(params),
	})
}

/**
 * 获取渠道列表
 */
export function getChannel(params: any) {
	return http.post(`channel/select`, {
		body: JSON.stringify(params),
	})
}
/**
 * 业务审核
 */
export function reviewForB(params: any) {
	return http.post(`infoManage/reviewForB`, {
		body: JSON.stringify(params),
	})
}
/**
 * 法务审核
 */
export function reviewForL(params: any) {
	return http.post(`infoManage/reviewForL`, {
		body: JSON.stringify(params),
	})
}
/**
 * 审核详情
 */
export function getReviewInfo(params: any) {
	return http.post(`infoManage/selectOneReviewer`, {
		body: JSON.stringify(params),
	})
}
/**
 * code=>查询审核数据
 */
export function getReviewInfoForCdoe(params: any) {
	return http.post(`infoManage/getReviewInfoForCdoe`, {
		body: JSON.stringify(params),
	})
}
/**
 * code=>业务审核
 */
export function reviewForBCdoe(params: any) {
	return http.post(`infoManage/reviewForBCdoe`, {
		body: JSON.stringify(params),
	})
}
/**
 * code=>法务审核
 */
export function reviewForLCode(params: any) {
	return http.post(`infoManage/reviewForLCode`, {
		body: JSON.stringify(params),
	})
}
/**
 * 撤销审核接口
 */
export function revokeReview(params: any) {
	return http.post(`infoManage/revokeReview`, {
		body: JSON.stringify(params),
	})
}
/**
 * 撤销审核接口(新)
 */
export function revokeReviewNew(params: any) {
	return http.post(`hotelapprovalform/recallTask`, {
		body: JSON.stringify(params),
	})
}

/**
 * 文字转音频
 */
export function textToAudio(params: { tarText: string }) {
	return http.post(`audio/textToAudio`, {
		body: JSON.stringify(params),
	})
}

/**
 * 音频转文字
 */
export function audioToText(file: any) {
	const myform = new FormData()
	myform.append('file', file)
	return http.post(`audio/audioTotext`, {
		formData: true,
		body: myform,
	})
}

/**
 * 视频制作
 */
export function videoConvert(params: any, userid: any) {
	return http.post(`ffmpeg/videoManage/convert`, {
		body: JSON.stringify({
			...params,
			userid,
		}),
	})
}

/**
 * 登录
 */
export function login(params: any) {
	return http.post(`noAuthority/login`, {
		body: JSON.stringify(params),
	})
}

/**
 * 退出登录
 */
export function logout(params?: any) {
	return http.post(`noAuthority/logout`, {})
}

/**
 * 获取用户信息
 */
export function getUserInfo(params: { access_token: string }) {
	return http.get(`authority/userInfo`, {
		body: params,
	})
}

/**
 * 获取权限
 */
export function getAuthority(params?: any) {
	return http.get(`authority/get`, {})
}

/**
 * 通过工号获取权限
 */
// export function getAuthorityByWordId(params: { workId: number }) {
// 	return http.get(`authority/byWordId`, {
// 		body: params,
// 	})
// }

/**
 * 获取日志
 */
export function getOneRecord(params: any) {
	return http.post(`infoManage/selectOneRecord`, {
		body: JSON.stringify(params),
	})
}

/**
 * 获取日志(新)
 */
export function getOneRecordNew(params: any) {
	return http.post(`hotelapprovalform/selectApproveLog`, {
		body: JSON.stringify(params),
	})
}

/**
 * 获取全部字段
 */
export function getAllField(params: {}) {
	return http.post(`typeManage/selectAllField`, {
		body: JSON.stringify(params),
	})
}

/**
 * 获取视频信息
 */
export function getVideoMetaInfo(params: {}) {
	return http.post(`ffmpeg/videoManage/getVideoMetaInfo`, {
		body: JSON.stringify(params),
	})
}

/**
 * 获取酒店列表
 */
export function getHotelList(params: {}) {
	return http.post(`etl/searchList`, {
		body: JSON.stringify(params),
	})
}
/**
 * 获取业务线数据
 */
export function getBusiness(params: {}) {
	return http.post(`etl/getInfo`, {
		body: JSON.stringify(params),
	})
}

/**
 * 业务接入综合查询接口
 */
export function getEtlSearch(params: {}) {
	return http.post(`etl/search`, {
		body: JSON.stringify(params),
	})
}
/**
 * 高级视频合成
 */
export function videoEditConvert(params: {}) {
	return http.post(`videoEdit/convert`, {
		body: JSON.stringify({
			st_is_works: '1',
			...params,
			is_del: '0',
		}),
	})
}
/**
 * 自动生成字幕接口
 */
export function videoTotextMul(params: {}) {
	return http.post(`audio/videoTotextMul`, {
		body: JSON.stringify(params),
	})
}

/**
 * 公司添加
 */
export function addCompany(params: {}) {
	return http.post(`company/add`, {
		body: JSON.stringify(params),
	})
}

/**
 * 公司删除
 */
export function delCompany(params: {}) {
	return http.post(`company/delete`, {
		body: JSON.stringify(params),
	})
}
/**
 * 公司查询
 */
export function getCompanyList(params: {}) {
	return http.post(`company/selectAll`, {
		body: JSON.stringify(params),
	})
}

/**
 * 公司下的所以用户
 */
export function getCompanyUserList(params: {}) {
	return http.post(`company/selectForCompanyId`, {
		body: JSON.stringify(params),
	})
}
/**
 * 用户关联的所以公司
 */
export function getUserCompanyList(params: {}) {
	return http.post(`company/selectForUserId`, {
		body: JSON.stringify(params),
	})
}
/**
 * 通过用户名、手机号查询用户
 */
export function userSearch(params: {}) {
	return http.post(`user/search`, {
		body: JSON.stringify(params),
	})
}
/**
 * 公司添加人员
 */
export function addUser(params: {}) {
	return http.post(`company/addUser`, {
		body: JSON.stringify(params),
	})
}
/**
 * 公司删除人员
 */
export function delUser(params: {}) {
	return http.post(`company/delUser`, {
		body: JSON.stringify(params),
	})
}

/**
 * 视频流列表
 */
export function dlManageGetVideoList(params: {}) {
	return http.post(`dlManage/getVideoList`, {
		body: JSON.stringify(params),
	})
}
/**
 * 视频流权重删除
 */
export function dlManageDeleteVideo(params: {}) {
	return http.post(`dlManage/delete`, {
		body: JSON.stringify(params),
	})
}

/**
 * 视频流权重修改
 */
export function dlManageUpdateVideo(params: {}) {
	return http.post(`dlManage/update`, {
		body: JSON.stringify(params),
	})
}

/**
 * 获取商品信息
 */
export function checkSaleUrl(params: {}) {
	return http.post(`goods/detail`, {
		body: JSON.stringify(params),
	})
}

export function selectForVid(params: {}) {
	return http.post(`goods/selectForVid`, {
		body: JSON.stringify(params),
	})
}

export function checkPublishDl(params: {}) {
	return http.post(`infoManage/checkPublishDl`, {
		body: JSON.stringify(params),
	})
}
/**
 * 提交问卷
 */
export function submitQuestion(params: {}) {
	return http.post(`questionnaire/addQuestion`, {
		body: JSON.stringify(params),
	})
}
export function getQuestionList(params: {}) {
	return http.post(`questionnaire/getMyQuestion`, {
		body: JSON.stringify(params),
	})
}
export function questiondel(params: {}) {
	return http.post(`questionnaire/del`, {
		body: JSON.stringify(params),
	})
}
/**
 * 酒旅审核
 */
export function getChannelAccount(params: {}) {
	return http.get(`newMedia/getChannelAccount`, {
		body: params,
	})
}
export function getAllChannel() {
	return http.get(`newMedia/getAllChannel`, {})
}
export function selectCheckList(params: {}) {
	return http.post(`infoManage/selectCheckList`, {
		body: JSON.stringify(params),
	})
}
// 查询审核列表(新)
export function selectCheckListNew(params: {}) {
	return http.post(`hotelapprovalform/findList`, {
		body: JSON.stringify(params),
	})
}

export function selectHotelCount(params: number) {
	return http.get(`infoManage/selectHotelCount?stPbl=${params}`, {})
}
export function selectHotelCountNew() {
	return http.post(`hotelapprovalform/countHotel`, {
		body: JSON.stringify({}),
	})
}

export function getMediaList(params: {}) {
	return http.get(`brandBasic/mediaForm`, {
		body: params,
	})
}
export function getAdvertisingList() {
	return http.get(`brandBasic/launchType`, {})
}
export function getProvinceList() {
	return http.get(`brandBasic/getProvinces`, {})
}
export function getCityCode(params: {}) {
	return http.get(`brandBasic/getCity/${params}`, {})
}
export function reviewWorkflow(params: any) {
	return http.post(`infoManage/reviewWorkflow`, {
		body: JSON.stringify(params),
	})
}
export function reviewWorkflowCode(params: any) {
	return http.post(`infoManage/reviewWorkflowCode`, {
		body: JSON.stringify(params),
	})
}
export { Login }
/// 迭代新增接口--
export function startApprove(params: any) {
	return http.post(`approvalform/startApprove`, {
		body: JSON.stringify(params),
	})
}
export function selectApprove(businessKey: any) {
	return http.post(`approvalform/selectApprove`, {
		body: JSON.stringify({ businessKey }),
	})
}
export function findList(params: any) {
	const { pageNum, pageSize, ...rest } = params
	const data = {
		...rest,
		pageNum: Number(pageNum),
		pageSize: Number(pageSize),
	}
	return http.post(`approvalform/findList`, {
		body: JSON.stringify({ ...data }),
	})
}

export function deleteApprove(id: string) {
	return http.post(`approvalform/deleteApprove`, {
		body: JSON.stringify({ id }),
	})
}

export function selectConfigCenter(key: string) {
	return http.get(`approvalform/selectConfigCenter?key=${key}`, {})
}
